import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const TransactionText = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin-top: 20px;
`;

export const TransactionSearchFlex = styled.div`
    margin-top: 20px;
    width: 100%;
`;

export const TransactionCard = styled.div`
    display: flex;
    margin-top: 15px;
    cursor: pointer;
`;

export const Hr = styled.div`
    display: flex;
    height: 0px;
    border: 1px solid #e7e7f0;
`;

export const NoResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-top: 20px;
`;
